import store, {types as storeTypes} from '../../vuex'

export default {
    time : new Date().getTime(),
    authRequired({router, route, ajax, success}){
        if(ajax){
            this._authOKHandler = success;
            store.commit(storeTypes.SHOW_AUTH_REQUIRED_DLG, true)
            return;
        }
        router({
            path: '/account/login',
            query: {returnUrl: route ? route.fullPath : ''}
        })
    },
    /**
     * authRequired成功后的回调(ajax下有效)
     */
    authOK(){
        this._authOKHandler && this._authOKHandler();
    }
}


// WEBPACK FOOTER //
// ./src/modules/account/auth.js